import { Box, Grid, Tooltip, Typography, Link as MuiLink } from "@mui/material";
import React, { memo } from "react";

const CARD_HEIGHT = 300;

const StatisticsCard = memo(({ title, type, data = [], maxVisible = null }) => {
  const commonTextStyle = {
    fontSize: "15px",
    color: "#1186c0",
  };

  const hasData = Array.isArray(data) && data.length > 0;
  const scrollHeight =
    maxVisible && type === "table" ? `${maxVisible * 35}px` : "auto";

  return (
    <Box
      sx={{
        backgroundColor: "#fcfbfd",
        p: 2,
        height: `${CARD_HEIGHT}px`,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h6" align="center" pb={2} color="#9a85bb">
        {title}
      </Typography>

      {!hasData ? (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography align="center" color="text.secondary" fontSize="16px">
            No data to display
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            overflowY: data?.length > (maxVisible || 2) ? "auto" : "visible",
            pr: 1,
            ...(maxVisible &&
              type === "table" && {
                maxHeight: scrollHeight,
              }),
          }}
        >
          {type === "table" ? (
            <table
              width="100%"
              style={{
                ...commonTextStyle,
                borderSpacing: "0 4px",
                tableLayout: "fixed",
              }}
            >
              <colgroup>
                <col style={{ width: "70%" }} />
                <col style={{ width: "30%" }} />
              </colgroup>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td
                      align="left"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Tooltip title={item?.name ? item?.name : item?.link} arrow>
                        <MuiLink
                          href={item?.link ? item?.link : item?.name}
                          target="_blank"
                          rel="noopener noreferrer"
                          underline="hover"
                          color="inherit"
                          sx={{
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item?.name ? item?.name : item?.link}
                        </MuiLink>
                      </Tooltip>
                    </td>
                    <td align="right">{item.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <ul
              style={{
                ...commonTextStyle,
                paddingLeft: "16px",
                margin: 0,
                listStylePosition: "inside",
              }}
            >
              {data.map((item, index) => (
                <li key={index} style={{ marginBottom: 6 }}>
                  {item}
                </li>
              ))}
            </ul>
          )}
        </Box>
      )}
    </Box>
  );
});

const Statistics = memo(
  ({
    showDashboardReports = false,
    linkData = [],
    topCategories = [],
    trends = [],
    flaggedConcerns = [],
  }) => {
    return (
      <Grid container alignItems="stretch" spacing={2}>
        {showDashboardReports && (
          <Grid item xs={12} md={6}>
            <StatisticsCard
              title="Top 3 Categories"
              type="list"
              data={topCategories}
            />
          </Grid>
        )}
        <Grid item xs={12} md={showDashboardReports ? 6 : 12}>
          <StatisticsCard
            title="Referral Links and Qtys"
            type="table"
            data={linkData}
          />
        </Grid>
        {showDashboardReports && (
          <Grid item xs={12} md={6}>
            <StatisticsCard title="Trends" type="list" data={trends} />
          </Grid>
        )}
        {showDashboardReports && (
          <Grid item xs={12} md={6}>
            <StatisticsCard
              title="Flagged Concerns"
              type="list"
              data={flaggedConcerns}
            />
          </Grid>
        )}
      </Grid>
    );
  }
);

export default Statistics;
